/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageTargetSummary,
  ToolUsageTargetSummary$inboundSchema,
} from "./toolusagetargetsummary.js";

/**
 * Top MCP and tool usage targets for the selected filters and time range
 */
export type GetToolUsageTargetsResult = {
  /**
   * Top usage targets for the selected filters and time range
   */
  targets: Array<ToolUsageTargetSummary>;
};

/** @internal */
export const GetToolUsageTargetsResult$inboundSchema: z.ZodMiniType<
  GetToolUsageTargetsResult,
  unknown
> = z.object({
  targets: z.array(ToolUsageTargetSummary$inboundSchema),
});

export function getToolUsageTargetsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageTargetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageTargetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageTargetsResult' from JSON`,
  );
}
